import { render } from "./DolarPrice.vue?vue&type=template&id=913906cc"
import script from "./DolarPrice.vue?vue&type=script&lang=js"
export * from "./DolarPrice.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__